// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"lgEC2":[function(require,module,exports,__globalThis) {
var _utils = require("./utils");
(0, _utils.ping)();

},{"./utils":"4UGOV"}],"4UGOV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ping", ()=>ping);
var _fingerprint = require("./fingerprint");
var _hash = require("./hash");
var _typeGuards = require("./typeGuards");
var _visitorPing = require("./visitor-ping");
var _visitorStorage = require("./visitor-storage");
const tryOrEmpty = (fn)=>(...args)=>{
        try {
            const result = fn(...args);
            if ((0, _typeGuards.isPromiseLike)(result)) return result.then((v)=>v, (error)=>`${error}`);
            return result;
        } catch (e) {
            return `${e}`;
        }
    };
async function ping() {
    let start = Date.now();
    const fp = await (0, _fingerprint.createFingerprint)(tryOrEmpty, (0, _hash.hash));
    const visitorId = (0, _visitorStorage.getVisitorId)();
    const elapsed = Date.now() - start;
    (0, _visitorPing.ping1)({
        browserHash: fp.browserHash,
        visitorId,
        elapsed
    });
    document.addEventListener("visibilitychange", ()=>{
        const type = document.hidden ? "unload" : "review";
        if (type === "review") start = Date.now();
        const elapsed = type == "unload" ? Date.now() - start : 0;
        (0, _visitorPing.ping1)({
            browserHash: fp.browserHash,
            visitorId,
            elapsed,
            type
        });
    });
    const done = Date.now();
    console.log(`Created fingerprint in ${done - start}ms`);
}

},{"./fingerprint":"e50TT","./hash":"8fXBQ","./typeGuards":"iMzJ4","./visitor-ping":"53L55","./visitor-storage":"9wDuh","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"e50TT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "createFingerprint", ()=>createFingerprint);
var _canvas = require("./canvas");
var _math = require("./math");
var _timezone = require("./timezone");
var _hardwareConcurrency = require("./hardwareConcurrency");
var _deviceMemory = require("./deviceMemory");
var _webgl = require("./webgl");
var _vendorFlavors = require("./vendorFlavors");
var _languages = require("./languages");
var _mediaMatches = require("./mediaMatches");
var _supportedMediaTypes = require("./supportedMediaTypes");
var _screen = require("./screen");
var _nativeNavigatorFunctions = require("./nativeNavigatorFunctions");
var _permissions = require("./permissions");
var _vendor = require("./vendor");
var _userAgent = require("./user-agent");
const noop = (fn)=>fn;
async function _create(wrap = noop) {
    const { widthDiff, heightDiff } = wrap((0, _screen.getScreenDiff))();
    const { height, width } = wrap((0, _screen.getScreenDimentions))();
    const [permissions, canvas] = await Promise.all([
        wrap((0, _permissions.getPermissions))(),
        wrap((0, _canvas.getCanvasFingerprint))()
    ]);
    return {
        canvas,
        math: wrap((0, _math.getMathFingerprint))(),
        timezone: wrap((0, _timezone.getTimezone))(),
        hardwareConcurrency: wrap((0, _hardwareConcurrency.getHardwareConcurrency))(),
        deviceMemory: wrap((0, _deviceMemory.getDeviceMemory))(),
        webglInfo: wrap((0, _webgl.getWebGLInfo))(),
        vendorFlavors: wrap((0, _vendorFlavors.getVendorFlavors))(),
        languages: wrap((0, _languages.getLanguages))(),
        mediaMatches: wrap((0, _mediaMatches.getMediaMatches))(),
        supportedAudioTypes: wrap((0, _supportedMediaTypes.getSupportedAudioTypes))(),
        supportedVideoTypes: wrap((0, _supportedMediaTypes.getSupportedVideoTypes))(),
        screenWidthDiff: widthDiff,
        screenHeightDiff: heightDiff,
        computedHeight: height,
        computedWidth: width,
        nativeNavigatorFunctions: wrap((0, _nativeNavigatorFunctions.getNativeNavigatorFunctions))(),
        vendor: wrap((0, _vendor.getVendor))(),
        permissions,
        userAgent: wrap((0, _userAgent.getUserAgent))()
    };
}
async function createFingerprint(wrap = noop, hash) {
    const fp = await _create(wrap);
    return {
        ...fp,
        browserHash: hash ? hash(fp) : ""
    };
}

},{"./canvas":"b7ut5","./math":"1G3Bl","./timezone":"2QfYs","./hardwareConcurrency":"dQfIQ","./deviceMemory":"4GGIt","./webgl":"9MTBa","./vendorFlavors":"aBfrK","./languages":"dntTj","./mediaMatches":"g6jrI","./supportedMediaTypes":"87U6a","./screen":"2fvH0","./nativeNavigatorFunctions":"2OKgR","./permissions":"kogt4","./vendor":"7q98x","./user-agent":"iGUf8","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"b7ut5":[function(require,module,exports,__globalThis) {
// https://github.com/fingerprintjs/fingerprintjs/blob/v3.3.2/src/sources/canvas.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanvasFingerprint", ()=>getCanvasFingerprint);
var _utils = require("./utils");
function getCanvasFingerprint() {
    const ua = navigator.userAgent;
    if (ua.match(/;\s?Android\s[\d|\\.]+;/)) return Promise.resolve(ua);
    return new Promise((resolve)=>{
        (0, _utils.rafOrTimeout)(()=>{
            const canvasFingerPrint = getCanvasFingerprintSync();
            resolve(canvasFingerPrint);
        });
    });
}
// https://www.browserleaks.com/canvas#how-does-it-work
function getCanvasFingerprintSync() {
    const [canvas, context] = makeCanvasContext();
    if (!isSupported(canvas, context)) return {
        winding: false,
        geometry: "",
        text: ""
    };
    return {
        winding: doesSupportWinding(context),
        geometry: makeGeometryImage(canvas, context),
        // Text is unstable:
        // https://github.com/fingerprintjs/fingerprintjs/issues/583
        // https://github.com/fingerprintjs/fingerprintjs/issues/103
        // Therefore it's extracted into a separate image.
        text: makeTextImage(canvas, context)
    };
}
function makeCanvasContext() {
    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    return [
        canvas,
        canvas.getContext("2d")
    ];
}
function isSupported(canvas, context) {
    // TODO: look into: https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
    return !!(context && canvas.toDataURL);
}
function doesSupportWinding(context) {
    // https://web.archive.org/web/20170825024655/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
    context.rect(0, 0, 10, 10);
    context.rect(2, 2, 6, 6);
    return !context.isPointInPath(5, 5, "evenodd");
}
function makeTextImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 240;
    canvas.height = 60;
    context.textBaseline = "alphabetic";
    context.fillStyle = "#f60";
    context.fillRect(100, 1, 62, 20);
    context.fillStyle = "#069";
    // It's important to use explicit built-in fonts in order to exclude the affect of font preferences
    // (there is a separate entropy source for them).
    context.font = '11pt "Times New Roman"';
    // The choice of emojis has a gigantic impact on rendering performance (especially in FF).
    // Some newer emojis cause it to slow down 50-200 times.
    // There must be no text to the right of the emoji, see https://github.com/fingerprintjs/fingerprintjs/issues/574
    // A bare emoji shouldn't be used because the canvas will change depending on the script encoding:
    // https://github.com/fingerprintjs/fingerprintjs/issues/66
    // Escape sequence shouldn't be used too because Terser will turn it into a bare unicode.
    const printedText = `Cwm fjordbank gly ${String.fromCharCode(55357, 56835)}`;
    context.fillText(printedText, 2, 15);
    context.fillStyle = "rgba(102, 204, 0, 0.2)";
    context.font = "18pt Arial";
    context.fillText(printedText, 4, 45);
    return save(canvas);
}
function makeGeometryImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 122;
    canvas.height = 110;
    // Canvas blending
    // https://web.archive.org/web/20170826194121/http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
    // http://jsfiddle.net/NDYV8/16/
    context.globalCompositeOperation = "multiply";
    for (const [color, x, y] of [
        [
            "#f2f",
            40,
            40
        ],
        [
            "#2ff",
            80,
            40
        ],
        [
            "#ff2",
            60,
            80
        ]
    ]){
        context.fillStyle = color;
        context.beginPath();
        context.arc(x, y, 40, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
    }
    // Canvas winding
    // https://web.archive.org/web/20130913061632/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // http://jsfiddle.net/NDYV8/19/
    context.fillStyle = "#f9c";
    context.arc(60, 60, 60, 0, Math.PI * 2, true);
    context.arc(60, 60, 20, 0, Math.PI * 2, true);
    context.fill("evenodd");
    return save(canvas);
}
function save(canvas) {
    // TODO: look into: https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
    return canvas.toDataURL();
}

},{"./utils":"kwv1o","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"kwv1o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toInt", ()=>toInt);
parcelHelpers.export(exports, "toFloat", ()=>toFloat);
parcelHelpers.export(exports, "rafOrTimeout", ()=>rafOrTimeout);
function toInt(value, replaceNaN) {
    const possibleNumber = parseInt(value);
    return isNaN(possibleNumber) ? replaceNaN : possibleNumber;
}
function toFloat(value, replaceNan) {
    const possibleFloat = parseFloat(value);
    return isNaN(possibleFloat) ? replaceNan : possibleFloat;
}
function fireOnce(cb) {
    let fired = false;
    return ()=>{
        if (fired) return;
        fired = true;
        cb();
    };
}
function defer(cb) {
    cb = fireOnce(cb);
    const visible = document.visibilityState !== "hidden";
    const fun = visible ? window.requestAnimationFrame || window.setTimeout : window.setTimeout;
    if (visible) {
        const fireCallbackWhenHidden = ()=>{
            if (document.visibilityState !== "hidden") return;
            cb();
        };
        document.addEventListener("visibilitychange", fireCallbackWhenHidden);
    }
    fun(cb);
}
function rafOrTimeout(fn) {
    return new Promise((resolve)=>{
        defer(()=>resolve(fn()));
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"gA8Ay":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"1G3Bl":[function(require,module,exports,__globalThis) {
// https://github.com/fingerprintjs/fingerprintjs/blob/v3.3.2/src/sources/math.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @see https://gitlab.torproject.org/legacy/trac/-/issues/13018
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=531915
 */ parcelHelpers.export(exports, "getMathFingerprint", ()=>getMathFingerprint);
const noop = ()=>0;
// Native operations
const acos = Math.acos || noop;
const acosh = Math.acosh || noop;
const asin = Math.asin || noop;
const asinh = Math.asinh || noop;
const atanh = Math.atanh || noop;
const atan = Math.atan || noop;
const sin = Math.sin || noop;
const sinh = Math.sinh || noop;
const cos = Math.cos || noop;
const cosh = Math.cosh || noop;
const tan = Math.tan || noop;
const tanh = Math.tanh || noop;
const exp = Math.exp || noop;
const expm1 = Math.expm1 || noop;
const log1p = Math.log1p || noop;
// Operation polyfills
const acoshPf = (value)=>Math.log(value + Math.sqrt(value * value - 1));
const asinhPf = (value)=>Math.log(value + Math.sqrt(value * value + 1));
const atanhPf = (value)=>Math.log((1 + value) / (1 - value)) / 2;
const sinhPf = (value)=>Math.exp(value) - 1 / Math.exp(value) / 2;
const coshPf = (value)=>(Math.exp(value) + 1 / Math.exp(value)) / 2;
const expm1Pf = (value)=>Math.exp(value) - 1;
const tanhPf = (value)=>(Math.exp(2 * value) - 1) / (Math.exp(2 * value) + 1);
const log1pPf = (value)=>Math.log(1 + value);
function getMathFingerprint() {
    // Note: constant values are empirical
    return {
        acos: acos(0.123124234234234242),
        acosh: acosh(1e308),
        acoshPf: acoshPf(1e154),
        asin: asin(0.123124234234234242),
        asinh: asinh(1),
        asinhPf: asinhPf(1),
        atanh: atanh(0.5),
        atanhPf: atanhPf(0.5),
        atan: atan(0.5),
        sin: sin(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
        sinh: sinh(1),
        sinhPf: sinhPf(1),
        cos: cos(10.000000000123),
        cosh: cosh(1),
        coshPf: coshPf(1),
        tan: tan(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
        tanh: tanh(1),
        tanhPf: tanhPf(1),
        exp: exp(1),
        expm1: expm1(1),
        expm1Pf: expm1Pf(1),
        log1p: log1p(10),
        log1pPf: log1pPf(10),
        powPI: Math.pow(Math.PI, -100)
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"2QfYs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTimezone", ()=>getTimezone);
function getTimezone() {
    if (Intl.DateTimeFormat) return Intl.DateTimeFormat().resolvedOptions().timeZone;
    // modern browsers might never need the code below
    const offset = new Date().getTimezoneOffset();
    return `${offset}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"dQfIQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHardwareConcurrency", ()=>getHardwareConcurrency);
var _utils = require("./utils");
function getHardwareConcurrency() {
    return (0, _utils.toInt)(navigator.hardwareConcurrency, -1);
}

},{"./utils":"kwv1o","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"4GGIt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDeviceMemory", ()=>getDeviceMemory);
var _utils = require("./utils");
function getDeviceMemory() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (0, _utils.toFloat)(navigator.deviceMemory, -1);
}

},{"./utils":"kwv1o","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"9MTBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWebGLInfo", ()=>getWebGLInfo);
function getWebGLInfo() {
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl");
    const rendererInfo = gl?.getExtension("WEBGL_debug_renderer_info");
    if (!rendererInfo || !gl) return {
        vendor: "",
        renderer: ""
    };
    return {
        vendor: gl.getParameter(rendererInfo.UNMASKED_VENDOR_WEBGL),
        renderer: gl.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL)
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"aBfrK":[function(require,module,exports,__globalThis) {
// This is a mix of:
// - https://github.com/fingerprintjs/fingerprintjs/blob/master/src/sources/vendor.ts
// - https://github.com/fingerprintjs/fingerprintjs/blob/master/src/sources/vendor_flavors.ts
/**
 * Checks for browser-specific (not engine specific) global variables to tell browsers with the same engine apart.
 * Only somewhat popular browsers are considered.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVendorFlavors", ()=>getVendorFlavors);
function getVendorFlavors() {
    const vendor = navigator.vendor || "";
    const flavors = [
        vendor
    ];
    for (const key of [
        // Blink and some browsers on iOS
        "chrome",
        // Safari on macOS
        "safari",
        // Chrome on iOS (checked in 85 on 13 and 87 on 14)
        "__crWeb",
        "__gCrWeb",
        // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
        "yandex",
        // Yandex Browser on iOS (checked in 21.2 on 14)
        "__yb",
        "__ybro",
        // Firefox on iOS (checked in 32 on 14)
        "__firefox__",
        // Edge on iOS (checked in 46 on 14)
        "__edgeTrackingPreventionStatistics",
        "webkit",
        // Opera Touch on iOS (checked in 2.6 on 14)
        "oprt",
        // Samsung Internet on Android (checked in 11.1)
        "samsungAr",
        // UC Browser on Android (checked in 12.10 and 13.0)
        "ucweb",
        "UCShellJava",
        // Puffin on Android (checked in 9.0)
        "puffinDevice"
    ]){
        const value = window[key];
        if (value && typeof value === "object") flavors.push(key);
    }
    return flavors.sort().join(",");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"dntTj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLanguages", ()=>getLanguages);
const langProperties = [
    "language",
    "browserLanguage",
    "systemLanguage",
    "userLanguage"
];
function getLanguages() {
    const languages = navigator.languages || [];
    const additionalLanguages = langProperties.map((prop)=>navigator[prop] || "").filter(Boolean);
    return languages.concat(additionalLanguages).join(",");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"g6jrI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMediaMatches", ()=>getMediaMatches);
parcelHelpers.export(exports, "isLandscape", ()=>isLandscape);
function doesMatch(type, value) {
    return matchMedia(`(${type}: ${value})`).matches;
}
const invertedColors = "inverted-colors";
// taken from https://github.com/fingerprintjs/fingerprintjs/blob/master/src/sources/inverted_colors.ts
function getColorsInverted() {
    if (doesMatch(invertedColors, "inverted")) return 2;
    if (doesMatch(invertedColors, "none")) return 1;
    return 0;
}
const forcedColors = "forced-colors";
// taken from https://github.com/fingerprintjs/fingerprintjs/blob/master/src/sources/forced_colors.ts
function getColorsForced() {
    if (doesMatch(forcedColors, "active")) return 2;
    if (doesMatch(forcedColors, "none")) return 1;
    return 0;
}
// rec2020 includes p3 and p3 includes srgb
const gamuts = [
    "srgb",
    "p3",
    "rec2020"
];
const colorGamut = "color-gamut";
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/color-gamut
 */ function getColorGamut() {
    for(let i = 0; i < gamuts.length; i++){
        const gamut = gamuts[i];
        if (matchMedia(`(${colorGamut}: ${gamut})`).matches) return i + 1;
    }
    return 0;
}
const dynamicRange = "dynamic-range";
function getHDR() {
    if (doesMatch(dynamicRange, "high")) return 2;
    if (doesMatch(dynamicRange, "standard")) return 1;
    return 0;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */ const prefersReducedMotion = "prefers-reduced-motion";
function getMotionReduced() {
    if (doesMatch(prefersReducedMotion, "reduce")) return 2;
    if (doesMatch(prefersReducedMotion, "no-preference")) return 1;
    return 0;
}
function getMediaMatches() {
    return getMotionReduced() * 10000 + getHDR() * 1000 + getColorGamut() * 100 + getColorsInverted() * 10 + getColorsForced();
}
function isLandscape() {
    return doesMatch("orientation", "landscape");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"87U6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSupportedAudioTypes", ()=>getSupportedAudioTypes);
parcelHelpers.export(exports, "getSupportedVideoTypes", ()=>getSupportedVideoTypes);
const possibleAudioTypes = [
    "audio/3gpp",
    "audio/3gpp2",
    "audio/AMR-NB",
    "audio/AMR-WB",
    "audio/GSM",
    "audio/aac",
    "audio/basic",
    "audio/flac",
    "audio/midi",
    "audio/mpeg",
    'audio/mp4; codecs="mp4a.40.2"',
    'audio/mp4; codecs="ac-3"',
    'audio/mp4; codecs="ec-3"',
    'audio/ogg; codecs="flac"',
    'audio/ogg; codecs="vorbis"',
    'audio/ogg; codecs="opus"',
    'audio/wav; codecs="1"',
    'audio/webm; codecs="vorbis"',
    'audio/webm; codecs="opus"',
    "audio/x-aiff",
    "audio/x-mpegurl"
].sort();
const possibleVideoTypes = [
    'video/mp4; codecs="flac"',
    'video/mp4; codecs="H.264, mp3"',
    'video/mp4; codecs="H.264, aac"',
    'video/mpeg; codec="H.264"',
    'video/ogg; codecs="theora"',
    'video/ogg; codecs="opus"',
    'video/webm; codecs="vp9, opus"',
    'video/webm; codecs="vp8, vorbis"'
].sort();
const elements = {};
function canPlay(source, type) {
    const el = elements[source] || document.createElement(source);
    elements[source] = el;
    return el && el.canPlayType && el.canPlayType(type);
}
function toSupportDescription(source, type) {
    let supported;
    if (MediaSource.isTypeSupported) supported = MediaSource.isTypeSupported(type);
    const playable = canPlay(source, type);
    return {
        name: type,
        support: supported,
        playable
    };
}
function getSupportedAudioTypes() {
    return possibleAudioTypes.map((f)=>toSupportDescription("audio", f)).filter((f)=>!!f);
}
function getSupportedVideoTypes() {
    return possibleVideoTypes.map((f)=>toSupportDescription("video", f)).filter((f)=>!!f);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"2fvH0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScreenDiff", ()=>getScreenDiff);
parcelHelpers.export(exports, "getScreenDimentions", ()=>getScreenDimentions);
var _mediaMatches = require("./mediaMatches");
function getScreenDiff() {
    const { availHeight, availWidth, width, height } = window.screen;
    return {
        heightDiff: height - availHeight,
        widthDiff: width - availWidth
    };
}
function getScreenDimentions(win = window) {
    const pixelRatio = win.devicePixelRatio || 1;
    let { width, height } = win.screen;
    if (!(0, _mediaMatches.isLandscape)()) {
        const w = width;
        width = height;
        height = w;
    }
    return {
        width: width * pixelRatio,
        height: height * pixelRatio
    };
}

},{"./mediaMatches":"g6jrI","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"2OKgR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNativeNavigatorFunctions", ()=>getNativeNavigatorFunctions);
function isNative(obj) {
    return obj && typeof obj === "function" && obj.toString().indexOf("[native code]") > 0;
}
function getNativeNavigatorFunctions() {
    const props = [];
    for(const property in navigator){
        const value = navigator[property];
        if (isNative(value)) props.push(property);
    }
    return props.sort().join(",");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"kogt4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPermissions", ()=>getPermissions);
const possiblePermissions = [
    "accelerometer",
    "accessibility",
    "ambient-light-sensor",
    "camera",
    "clipboard-read",
    "clipboard-write",
    "geolocation",
    "background-sync",
    "magnetometer",
    "microphone",
    "midi",
    "notifications",
    "payment-handler",
    "persistent-storage",
    "push"
];
function getPermission(name) {
    if (!navigator.permissions) return Promise.resolve({
        name,
        present: false
    });
    return navigator.permissions.query({
        name: name
    }).then((_)=>({
            name,
            present: true
        }), (_)=>({
            name,
            present: false
        }));
}
function getPermissions() {
    const permissions = possiblePermissions.map((name)=>getPermission(name));
    return Promise.all(permissions);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"7q98x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVendor", ()=>getVendor);
function getVendor() {
    const n = navigator;
    return `${n.buildID},${n.product},${n.productSub},${n.vendor},${n.vendorSub}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"iGUf8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserAgent", ()=>getUserAgent);
function getUserAgent() {
    return navigator.userAgent || "none";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"8fXBQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hash", ()=>hash);
parcelHelpers.export(exports, "createVerifier", ()=>createVerifier);
var _murmurhash3Js = require("murmurhash3js");
function hash(payload) {
    if (typeof payload !== "string") payload = JSON.stringify(payload);
    return _murmurhash3Js.x64.hash128(payload);
}
function createVerifier({ browserHash, visitorId, baseName, type }) {
    const input = [
        browserHash,
        visitorId,
        type && type !== "load" ? type : undefined
    ].filter((s)=>s !== undefined).join(",");
    return _murmurhash3Js.x86.hash32(input, baseName || 0);
}

},{"murmurhash3js":"ijy1v","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"ijy1v":[function(require,module,exports,__globalThis) {
module.exports = require("d7a75bcd38c0f7ee");

},{"d7a75bcd38c0f7ee":"aNois"}],"aNois":[function(require,module,exports,__globalThis) {
/* jshint -W086: true */ // +----------------------------------------------------------------------+
// | murmurHash3js.js v3.0.1 // https://github.com/pid/murmurHash3js
// | A javascript implementation of MurmurHash3's x86 hashing algorithms. |
// |----------------------------------------------------------------------|
// | Copyright (c) 2012-2015 Karan Lyons                                       |
// | https://github.com/karanlyons/murmurHash3.js/blob/c1778f75792abef7bdd74bc85d2d4e1a3d25cfe9/murmurHash3.js |
// | Freely distributable under the MIT license.                          |
// +----------------------------------------------------------------------+
(function(root, undefined) {
    'use strict';
    // Create a local object that'll be exported or referenced globally.
    var library = {
        'version': '3.0.1',
        'x86': {},
        'x64': {}
    };
    // PRIVATE FUNCTIONS
    // -----------------
    function _x86Multiply(m, n) {
        //
        // Given two 32bit ints, returns the two multiplied together as a
        // 32bit int.
        //
        return (m & 0xffff) * n + (((m >>> 16) * n & 0xffff) << 16);
    }
    function _x86Rotl(m, n) {
        //
        // Given a 32bit int and an int representing a number of bit positions,
        // returns the 32bit int rotated left by that number of positions.
        //
        return m << n | m >>> 32 - n;
    }
    function _x86Fmix(h) {
        //
        // Given a block, returns murmurHash3's final x86 mix of that block.
        //
        h ^= h >>> 16;
        h = _x86Multiply(h, 0x85ebca6b);
        h ^= h >>> 13;
        h = _x86Multiply(h, 0xc2b2ae35);
        h ^= h >>> 16;
        return h;
    }
    function _x64Add(m, n) {
        //
        // Given two 64bit ints (as an array of two 32bit ints) returns the two
        // added together as a 64bit int (as an array of two 32bit ints).
        //
        m = [
            m[0] >>> 16,
            m[0] & 0xffff,
            m[1] >>> 16,
            m[1] & 0xffff
        ];
        n = [
            n[0] >>> 16,
            n[0] & 0xffff,
            n[1] >>> 16,
            n[1] & 0xffff
        ];
        var o = [
            0,
            0,
            0,
            0
        ];
        o[3] += m[3] + n[3];
        o[2] += o[3] >>> 16;
        o[3] &= 0xffff;
        o[2] += m[2] + n[2];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[1] += m[1] + n[1];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[0] += m[0] + n[0];
        o[0] &= 0xffff;
        return [
            o[0] << 16 | o[1],
            o[2] << 16 | o[3]
        ];
    }
    function _x64Multiply(m, n) {
        //
        // Given two 64bit ints (as an array of two 32bit ints) returns the two
        // multiplied together as a 64bit int (as an array of two 32bit ints).
        //
        m = [
            m[0] >>> 16,
            m[0] & 0xffff,
            m[1] >>> 16,
            m[1] & 0xffff
        ];
        n = [
            n[0] >>> 16,
            n[0] & 0xffff,
            n[1] >>> 16,
            n[1] & 0xffff
        ];
        var o = [
            0,
            0,
            0,
            0
        ];
        o[3] += m[3] * n[3];
        o[2] += o[3] >>> 16;
        o[3] &= 0xffff;
        o[2] += m[2] * n[3];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[2] += m[3] * n[2];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[1] += m[1] * n[3];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[1] += m[2] * n[2];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[1] += m[3] * n[1];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
        o[0] &= 0xffff;
        return [
            o[0] << 16 | o[1],
            o[2] << 16 | o[3]
        ];
    }
    function _x64Rotl(m, n) {
        //
        // Given a 64bit int (as an array of two 32bit ints) and an int
        // representing a number of bit positions, returns the 64bit int (as an
        // array of two 32bit ints) rotated left by that number of positions.
        //
        n %= 64;
        if (n === 32) return [
            m[1],
            m[0]
        ];
        else if (n < 32) return [
            m[0] << n | m[1] >>> 32 - n,
            m[1] << n | m[0] >>> 32 - n
        ];
        else {
            n -= 32;
            return [
                m[1] << n | m[0] >>> 32 - n,
                m[0] << n | m[1] >>> 32 - n
            ];
        }
    }
    function _x64LeftShift(m, n) {
        //
        // Given a 64bit int (as an array of two 32bit ints) and an int
        // representing a number of bit positions, returns the 64bit int (as an
        // array of two 32bit ints) shifted left by that number of positions.
        //
        n %= 64;
        if (n === 0) return m;
        else if (n < 32) return [
            m[0] << n | m[1] >>> 32 - n,
            m[1] << n
        ];
        else return [
            m[1] << n - 32,
            0
        ];
    }
    function _x64Xor(m, n) {
        //
        // Given two 64bit ints (as an array of two 32bit ints) returns the two
        // xored together as a 64bit int (as an array of two 32bit ints).
        //
        return [
            m[0] ^ n[0],
            m[1] ^ n[1]
        ];
    }
    function _x64Fmix(h) {
        //
        // Given a block, returns murmurHash3's final x64 mix of that block.
        // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
        // only place where we need to right shift 64bit ints.)
        //
        h = _x64Xor(h, [
            0,
            h[0] >>> 1
        ]);
        h = _x64Multiply(h, [
            0xff51afd7,
            0xed558ccd
        ]);
        h = _x64Xor(h, [
            0,
            h[0] >>> 1
        ]);
        h = _x64Multiply(h, [
            0xc4ceb9fe,
            0x1a85ec53
        ]);
        h = _x64Xor(h, [
            0,
            h[0] >>> 1
        ]);
        return h;
    }
    // PUBLIC FUNCTIONS
    // ----------------
    library.x86.hash32 = function(key, seed) {
        //
        // Given a string and an optional seed as an int, returns a 32 bit hash
        // using the x86 flavor of MurmurHash3, as an unsigned int.
        //
        key = key || '';
        seed = seed || 0;
        var remainder = key.length % 4;
        var bytes = key.length - remainder;
        var h1 = seed;
        var k1 = 0;
        var c1 = 0xcc9e2d51;
        var c2 = 0x1b873593;
        for(var i = 0; i < bytes; i = i + 4){
            k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24;
            k1 = _x86Multiply(k1, c1);
            k1 = _x86Rotl(k1, 15);
            k1 = _x86Multiply(k1, c2);
            h1 ^= k1;
            h1 = _x86Rotl(h1, 13);
            h1 = _x86Multiply(h1, 5) + 0xe6546b64;
        }
        k1 = 0;
        switch(remainder){
            case 3:
                k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
            case 2:
                k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
            case 1:
                k1 ^= key.charCodeAt(i) & 0xff;
                k1 = _x86Multiply(k1, c1);
                k1 = _x86Rotl(k1, 15);
                k1 = _x86Multiply(k1, c2);
                h1 ^= k1;
        }
        h1 ^= key.length;
        h1 = _x86Fmix(h1);
        return h1 >>> 0;
    };
    library.x86.hash128 = function(key, seed) {
        //
        // Given a string and an optional seed as an int, returns a 128 bit
        // hash using the x86 flavor of MurmurHash3, as an unsigned hex.
        //
        key = key || '';
        seed = seed || 0;
        var remainder = key.length % 16;
        var bytes = key.length - remainder;
        var h1 = seed;
        var h2 = seed;
        var h3 = seed;
        var h4 = seed;
        var k1 = 0;
        var k2 = 0;
        var k3 = 0;
        var k4 = 0;
        var c1 = 0x239b961b;
        var c2 = 0xab0e9789;
        var c3 = 0x38b34ae5;
        var c4 = 0xa1e38b93;
        for(var i = 0; i < bytes; i = i + 16){
            k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24;
            k2 = key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24;
            k3 = key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24;
            k4 = key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24;
            k1 = _x86Multiply(k1, c1);
            k1 = _x86Rotl(k1, 15);
            k1 = _x86Multiply(k1, c2);
            h1 ^= k1;
            h1 = _x86Rotl(h1, 19);
            h1 += h2;
            h1 = _x86Multiply(h1, 5) + 0x561ccd1b;
            k2 = _x86Multiply(k2, c2);
            k2 = _x86Rotl(k2, 16);
            k2 = _x86Multiply(k2, c3);
            h2 ^= k2;
            h2 = _x86Rotl(h2, 17);
            h2 += h3;
            h2 = _x86Multiply(h2, 5) + 0x0bcaa747;
            k3 = _x86Multiply(k3, c3);
            k3 = _x86Rotl(k3, 17);
            k3 = _x86Multiply(k3, c4);
            h3 ^= k3;
            h3 = _x86Rotl(h3, 15);
            h3 += h4;
            h3 = _x86Multiply(h3, 5) + 0x96cd1c35;
            k4 = _x86Multiply(k4, c4);
            k4 = _x86Rotl(k4, 18);
            k4 = _x86Multiply(k4, c1);
            h4 ^= k4;
            h4 = _x86Rotl(h4, 13);
            h4 += h1;
            h4 = _x86Multiply(h4, 5) + 0x32ac3b17;
        }
        k1 = 0;
        k2 = 0;
        k3 = 0;
        k4 = 0;
        switch(remainder){
            case 15:
                k4 ^= key.charCodeAt(i + 14) << 16;
            case 14:
                k4 ^= key.charCodeAt(i + 13) << 8;
            case 13:
                k4 ^= key.charCodeAt(i + 12);
                k4 = _x86Multiply(k4, c4);
                k4 = _x86Rotl(k4, 18);
                k4 = _x86Multiply(k4, c1);
                h4 ^= k4;
            case 12:
                k3 ^= key.charCodeAt(i + 11) << 24;
            case 11:
                k3 ^= key.charCodeAt(i + 10) << 16;
            case 10:
                k3 ^= key.charCodeAt(i + 9) << 8;
            case 9:
                k3 ^= key.charCodeAt(i + 8);
                k3 = _x86Multiply(k3, c3);
                k3 = _x86Rotl(k3, 17);
                k3 = _x86Multiply(k3, c4);
                h3 ^= k3;
            case 8:
                k2 ^= key.charCodeAt(i + 7) << 24;
            case 7:
                k2 ^= key.charCodeAt(i + 6) << 16;
            case 6:
                k2 ^= key.charCodeAt(i + 5) << 8;
            case 5:
                k2 ^= key.charCodeAt(i + 4);
                k2 = _x86Multiply(k2, c2);
                k2 = _x86Rotl(k2, 16);
                k2 = _x86Multiply(k2, c3);
                h2 ^= k2;
            case 4:
                k1 ^= key.charCodeAt(i + 3) << 24;
            case 3:
                k1 ^= key.charCodeAt(i + 2) << 16;
            case 2:
                k1 ^= key.charCodeAt(i + 1) << 8;
            case 1:
                k1 ^= key.charCodeAt(i);
                k1 = _x86Multiply(k1, c1);
                k1 = _x86Rotl(k1, 15);
                k1 = _x86Multiply(k1, c2);
                h1 ^= k1;
        }
        h1 ^= key.length;
        h2 ^= key.length;
        h3 ^= key.length;
        h4 ^= key.length;
        h1 += h2;
        h1 += h3;
        h1 += h4;
        h2 += h1;
        h3 += h1;
        h4 += h1;
        h1 = _x86Fmix(h1);
        h2 = _x86Fmix(h2);
        h3 = _x86Fmix(h3);
        h4 = _x86Fmix(h4);
        h1 += h2;
        h1 += h3;
        h1 += h4;
        h2 += h1;
        h3 += h1;
        h4 += h1;
        return ("00000000" + (h1 >>> 0).toString(16)).slice(-8) + ("00000000" + (h2 >>> 0).toString(16)).slice(-8) + ("00000000" + (h3 >>> 0).toString(16)).slice(-8) + ("00000000" + (h4 >>> 0).toString(16)).slice(-8);
    };
    library.x64.hash128 = function(key, seed) {
        //
        // Given a string and an optional seed as an int, returns a 128 bit
        // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
        //
        key = key || '';
        seed = seed || 0;
        var remainder = key.length % 16;
        var bytes = key.length - remainder;
        var h1 = [
            0,
            seed
        ];
        var h2 = [
            0,
            seed
        ];
        var k1 = [
            0,
            0
        ];
        var k2 = [
            0,
            0
        ];
        var c1 = [
            0x87c37b91,
            0x114253d5
        ];
        var c2 = [
            0x4cf5ad43,
            0x2745937f
        ];
        for(var i = 0; i < bytes; i = i + 16){
            k1 = [
                key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24,
                key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24
            ];
            k2 = [
                key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24,
                key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24
            ];
            k1 = _x64Multiply(k1, c1);
            k1 = _x64Rotl(k1, 31);
            k1 = _x64Multiply(k1, c2);
            h1 = _x64Xor(h1, k1);
            h1 = _x64Rotl(h1, 27);
            h1 = _x64Add(h1, h2);
            h1 = _x64Add(_x64Multiply(h1, [
                0,
                5
            ]), [
                0,
                0x52dce729
            ]);
            k2 = _x64Multiply(k2, c2);
            k2 = _x64Rotl(k2, 33);
            k2 = _x64Multiply(k2, c1);
            h2 = _x64Xor(h2, k2);
            h2 = _x64Rotl(h2, 31);
            h2 = _x64Add(h2, h1);
            h2 = _x64Add(_x64Multiply(h2, [
                0,
                5
            ]), [
                0,
                0x38495ab5
            ]);
        }
        k1 = [
            0,
            0
        ];
        k2 = [
            0,
            0
        ];
        switch(remainder){
            case 15:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 14)
                ], 48));
            case 14:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 13)
                ], 40));
            case 13:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 12)
                ], 32));
            case 12:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 11)
                ], 24));
            case 11:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 10)
                ], 16));
            case 10:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 9)
                ], 8));
            case 9:
                k2 = _x64Xor(k2, [
                    0,
                    key.charCodeAt(i + 8)
                ]);
                k2 = _x64Multiply(k2, c2);
                k2 = _x64Rotl(k2, 33);
                k2 = _x64Multiply(k2, c1);
                h2 = _x64Xor(h2, k2);
            case 8:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 7)
                ], 56));
            case 7:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 6)
                ], 48));
            case 6:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 5)
                ], 40));
            case 5:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 4)
                ], 32));
            case 4:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 3)
                ], 24));
            case 3:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 2)
                ], 16));
            case 2:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 1)
                ], 8));
            case 1:
                k1 = _x64Xor(k1, [
                    0,
                    key.charCodeAt(i)
                ]);
                k1 = _x64Multiply(k1, c1);
                k1 = _x64Rotl(k1, 31);
                k1 = _x64Multiply(k1, c2);
                h1 = _x64Xor(h1, k1);
        }
        h1 = _x64Xor(h1, [
            0,
            key.length
        ]);
        h2 = _x64Xor(h2, [
            0,
            key.length
        ]);
        h1 = _x64Add(h1, h2);
        h2 = _x64Add(h2, h1);
        h1 = _x64Fmix(h1);
        h2 = _x64Fmix(h2);
        h1 = _x64Add(h1, h2);
        h2 = _x64Add(h2, h1);
        return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
    };
    if (module.exports) exports = module.exports = library;
    exports.murmurHash3 = library;
})(this);

},{}],"iMzJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromiseLike", ()=>isPromiseLike);
function isPromiseLike(possiblePromise) {
    return possiblePromise && typeof possiblePromise.then === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"53L55":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ping1", ()=>ping1);
var _hash = require("./hash");
var _path = require("./path");
var _remoteLogging = require("./remote-logging");
function addImage(...segments) {
    const png = document.createElement("img");
    png.src = (0, _path.computePath)(...segments);
    png.style.cssText = "position: absolute; top: -100px";
    document.body.appendChild(png);
}
function cacheBuster() {
    return Math.floor(Math.random() * 100000000);
}
function ping1({ browserHash, visitorId, elapsed, type }) {
    type = type || "load";
    try {
        const baseName = cacheBuster();
        browserHash = browserHash || "-";
        visitorId = visitorId || "-";
        elapsed = elapsed || 0;
        const verifier = (0, _hash.createVerifier)({
            browserHash,
            visitorId,
            baseName,
            type
        });
        addImage("/pxl", type !== "load" ? type : "", `${browserHash}/${visitorId}/${elapsed}/${baseName}-${verifier}.png`);
    } catch (error) {
        (0, _remoteLogging.logError)(error);
    }
}

},{"./hash":"8fXBQ","./path":"6tkxn","./remote-logging":"jaW1Y","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"6tkxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "computePath", ()=>computePath);
function computeBasePath() {
    const script = document.getElementById("pingme");
    if (!script || !script.src) //bail out
    return "";
    const split = script.src.split("/");
    return `${split[0]}//${split[2]}`;
}
function computePath(...segments) {
    if (segments && segments.length > 1) {
        const path = segments.filter(Boolean).map((segments)=>segments.replace(/^\/|\/$/g, "")).join("/");
        return computePath(path);
    }
    const basePath = computeBasePath();
    let path = segments[0];
    if (!path) return basePath;
    if (path.indexOf("/") === 0) path = path.substring(1);
    return `${basePath}/${path}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"jaW1Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "logError", ()=>logError);
parcelHelpers.export(exports, "log", ()=>log);
var _etag = require("./etag");
var _fetch = require("./fetch");
var _path = require("./path");
function isError(e) {
    return e && e.message && e.name;
}
function logError(error) {
    let message;
    if (isError(error)) {
        message = `${error.name}: ${error.message}`;
        const stack = error.stack;
        if (stack) message += `\n${stack}`;
    } else message = error.message || JSON.stringify(error);
    return log("ERROR", message);
}
function log(level, message) {
    return (0, _fetch.postJson)((0, _path.computePath)("/log/hash"), {
        level,
        message,
        etag: (0, _etag.getEtag)()
    });
}

},{"./etag":"2RQ12","./fetch":"ihjRj","./path":"6tkxn","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"2RQ12":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEtag", ()=>getEtag);
const etag = "###[randomUUID]###".split(".");
function getEtag() {
    return (etag[1] || etag[0]).replace("randomUUID", `${Math.floor(Math.random() * 10000000000)}`).replace("###[", "").replace("]###", "");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"ihjRj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "postJson", ()=>postJson);
function postJson(path, payload) {
    return fetch(path, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"9wDuh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVisitorId", ()=>getVisitorId);
var _browserCookies = require("browser-cookies");
var _uuid = require("uuid");
var _etag = require("./etag");
var _hash = require("./hash");
const key = "__va";
function createVisitorId() {
    const id = (0, _uuid.v4)();
    const tag = (0, _etag.getEtag)();
    return (0, _hash.hash)(`${tag}.${id}`);
}
function getVisitorId() {
    const cookieVa = _browserCookies.get(key);
    const localStorageVa = localStorage.getItem(key);
    let vaValue = cookieVa || localStorageVa;
    if (vaValue && vaValue.length !== 32) vaValue = "";
    const id = vaValue || createVisitorId();
    // ensure/update the va value
    _browserCookies.set(key, id, {
        expires: 365
    });
    if (vaValue !== localStorageVa) localStorage.setItem(key, id);
    return id;
}

},{"browser-cookies":"hNq19","uuid":[["v4","1I33c","default"]],"./etag":"2RQ12","./hash":"8fXBQ","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"hNq19":[function(require,module,exports,__globalThis) {
exports.defaults = {};
exports.set = function(name, value, options) {
    // Retrieve options and defaults
    var opts = options || {};
    var defaults = exports.defaults;
    // Apply default value for unspecified options
    var expires = opts.expires || defaults.expires;
    var domain = opts.domain || defaults.domain;
    var path = opts.path !== undefined ? opts.path : defaults.path !== undefined ? defaults.path : '/';
    var secure = opts.secure !== undefined ? opts.secure : defaults.secure;
    var httponly = opts.httponly !== undefined ? opts.httponly : defaults.httponly;
    var samesite = opts.samesite !== undefined ? opts.samesite : defaults.samesite;
    // Determine cookie expiration date
    // If succesful the result will be a valid Date, otherwise it will be an invalid Date or false(ish)
    var expDate = expires ? new Date(// in case expires is an integer, it should specify the number of days till the cookie expires
    typeof expires === 'number' ? new Date().getTime() + expires * 864e5 : // else expires should be either a Date object or in a format recognized by Date.parse()
    expires) : 0;
    // Set cookie
    document.cookie = name.replace(/[^+#$&^`|]/g, encodeURIComponent) // Encode cookie name
    .replace('(', '%28').replace(')', '%29') + '=' + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) + // Encode cookie value (RFC6265)
    (expDate && expDate.getTime() >= 0 ? ';expires=' + expDate.toUTCString() : '') + // Add expiration date
    (domain ? ';domain=' + domain : '') + // Add domain
    (path ? ';path=' + path : '') + // Add path
    (secure ? ';secure' : '') + // Add secure option
    (httponly ? ';httponly' : '') + // Add httponly option
    (samesite ? ';samesite=' + samesite : ''); // Add samesite option
};
exports.get = function(name) {
    var cookies = document.cookie.split(';');
    // Iterate all cookies
    while(cookies.length){
        var cookie = cookies.pop();
        // Determine separator index ("name=value")
        var separatorIndex = cookie.indexOf('=');
        // IE<11 emits the equal sign when the cookie value is empty
        separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
        var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
        // Return cookie value if the name matches
        if (cookie_name === name) return decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
    // Return `null` as the cookie was not found
    return null;
};
exports.erase = function(name, options) {
    exports.set(name, '', {
        expires: -1,
        domain: options && options.domain,
        path: options && options.path,
        secure: 0,
        httponly: 0
    });
};
exports.all = function() {
    var all = {};
    var cookies = document.cookie.split(';');
    // Iterate all cookies
    while(cookies.length){
        var cookie = cookies.pop();
        // Determine separator index ("name=value")
        var separatorIndex = cookie.indexOf('=');
        // IE<11 emits the equal sign when the cookie value is empty
        separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
        // add the cookie name and value to the `all` object
        var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
        all[cookie_name] = decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
    return all;
};

},{}],"1I33c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"16Doz","./stringify.js":"kWWRY","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"16Doz":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"kWWRY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"kj0N2","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"kj0N2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"fhuay","@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}],"fhuay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gA8Ay"}]},["lgEC2"], "lgEC2", "parcelRequireee2e", {})

//# sourceMappingURL=ping.js.map
